module.exports = "/packs/media/images/strategy-tax-409c4c74aeeb3ef09da5cc24b728abd7.png";